module.exports = __webpack_public_path__ + "assets/icone-smartphone.fcc775f3.svg";